import { TERMINE_UPDATE_DESIGN_SETTINGS } from '@/domain/termine/hooks/graphql/mutation';
import { terminDesignAuswahlToGraphQLMap } from '@/domain/termine/shared/types/DesignAuswahl';
import { UpdateDesignSettingsInpuValues } from '@/domain/termine/shared/types/UpdateDesignSettingsInput';
import { useMutation } from '@apollo/client/react';

export function useUpdateDesignSettings() {
  const [mutate, { data, error, loading }] = useMutation(
    TERMINE_UPDATE_DESIGN_SETTINGS,
    {
      refetchQueries: [
        'GetTagesDaten',
        'GetTermineKalenderByStandortIdAndZeitraum',
      ],
      fetchPolicy: 'no-cache',
    },
  );

  const updateDesignSettings = async (
    props: UpdateDesignSettingsInpuValues,
  ) => {
    try {
      const result = await mutate({
        variables: {
          managerDesignSettingUpdateInput: {
            idManager: props.idManager,
            designAuswahl: terminDesignAuswahlToGraphQLMap[props.designAuswahl],
            seiten: props.seiten,
          },
        },
      });
      if (result.data?.termine_managerDesignSettingsUpdate.error) {
        throw new Error(
          result.data?.termine_managerDesignSettingsUpdate.error.message,
        );
      }
      return result.data?.termine_managerDesignSettingsUpdate;
    } catch (error) {
      throw error instanceof Error ? error : new Error(String(error));
    }
  };
  return {
    updateDesignSettings,
    response: data?.termine_managerDesignSettingsUpdate,
    loading,
    error,
  };
}
